import React, {useEffect, useState} from 'react';
import MyCalendar, {CalendarEvent} from "../../../../../components/Calendar/MyCalendar";
import {momentLocalizer} from "react-big-calendar";
import moment from "moment";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {useAppDispatch, useAppSelector} from "../../../../../helpers/redux";
import Text from "../../../../../components/Text/Text";
import {AbsentLogDetailModel} from "../../models";
import Divider from "../../../../../components/Layout/Divider";
import {isObjectEmpty} from "../../../../../helpers/checkEmptiness";
import {RootState} from "../../../../../app/store";
import {getHolidayCalendarEventList} from "../../../../master/holiday/holiday.reducer";
import {HiOutlineArrowLeft, HiOutlineArrowRight} from 'react-icons/hi';
import {Button} from "flowbite-react";
import {setAbsentReportDetailId, setAbsentReportDetailIndex} from "../../attendanceReport.reducer";
import FormLoader from "../../../../../components/Loader/FormLoader";

const localizer = momentLocalizer(moment);
const AbsenLogDetail = () => {
    const dispatch = useAppDispatch();

    const attendanceLogList = useAppSelector(
        (state) => state.attendanceReport.absentReportList ?? []
    );

    const absentDetail = useAppSelector(
        (state) => state.attendanceReport.absentReportDetail ?? {} as AbsentLogDetailModel
    );

    const isLoading = useAppSelector(
        (state) => state.attendanceReport.isLoading
    );

    const holidayEventList = useAppSelector(
        (state: RootState) => state.holiday.holidayCalendarEventList ?? []
    );

    const attendanceLogDetailIndex = useAppSelector(
        (state) => state.attendanceReport.absentReportDetailIndex
    );

    const absentReportDetailId = useAppSelector(
        (state) => state.attendanceReport.absentReportDetailId
    );

    // const eventList = useAppSelector(
    //     (state) => state.attendanceReport.absentReportEventDetail ?? []
    // );


    const [eventList, setEventList] = useState<CalendarEvent[]>([]);

    useEffect(() => {
        dispatch(getHolidayCalendarEventList({ skip: 0, take: 200 }));
    }, []);

    useEffect(() => {
        if (!isObjectEmpty(absentDetail)) {
            let detail = absentDetail.details;
            let _eventAbsent: CalendarEvent[] = detail.filter((item) => item.time !== 0).map((item) => {
                return {
                    title: item.time.toString(),
                    start: moment(item.date).toDate(),
                    end: moment(item.date).toDate(),
                    allDay: true,
                }
            });

            let _eventLeave = detail.filter((item) => item.leaveDuration !== 0).map((item) => {
                return {
                    title: `I = ${item.leaveDuration?.toString()}`,
                    start: moment(item.date).toDate(),
                    end: moment(item.date).toDate(),
                    allDay: true,
                }
            });

            let _eventAlpha = detail.filter((item) => {
                return !item.isDeducted && !item.isRefNote && item.leaveDuration === 0 && item.time === 0 && !item.isHoliday
            }).map((item) => {
                return {
                    title: `A`,
                    start: moment(item.date).toDate(),
                    end: moment(item.date).toDate(),
                    allDay: true,
                }
            });

            let _eventSick = detail.filter((item) => item.isRefNote).map((item) => {
                return {
                    title: `SS`,
                    start: moment(item.date).toDate(),
                    end: moment(item.date).toDate(),
                    allDay: true,
                }
            });

            let _eventHoliday = detail.filter((item) => item.isHoliday).map((item) => {
                return {
                    title: `C`,
                    start: moment(item.date).toDate(),
                    end: moment(item.date).toDate(),
                    allDay: true,
                }
            });

            setEventList([..._eventAbsent, ..._eventLeave, ..._eventAlpha, ..._eventSick, ..._eventHoliday, ...holidayEventList])
        }
    }, [absentDetail, holidayEventList]);

    const customDayPropGetter = (date: {
        getDate: () => number;
        getDay: () => number;
        getMonth: () => number;
        getFullYear: () => number;
    }) => {
        let obj = holidayEventList.find((element, index) => {
            if (
                new Date(element?.start).getDate() === date.getDate() &&
                new Date(element?.start).getMonth() === date.getMonth() &&
                new Date(element?.start).getFullYear() === date.getFullYear()
            ) {
                return holidayEventList[index];
            }
        });
        if (date.getDay() === 0) {
            return { className: "date_weekend", style: { backgroundColor: "#fde0e0" } };
        } else if (obj !== undefined) {
            return { className: "date_weekend", style: { backgroundColor: "#fde0e0" } };
        } else {
            return { style: { backgroundColor: "#fff" } };
        }
    };

    console.log(
        attendanceLogList.findIndex(
            (item) => item.userId === absentReportDetailId
        )
    );

    return (
        <div className="p-2 md:p-6 pt-2 md:pt-2 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <FormLoader isLoading={isLoading} label={'Fetching Data'}>
                <>
                    <Divider>
                        <Divider.LeftContent>
                            <Text
                                label="NIP"
                                value={absentDetail.nip ?? 'No Data'}
                            />
                            <Text label="Name" value={absentDetail.name} />
                            <Text label="Team" value={absentDetail.team} />
                            <Text label="Role" value={absentDetail.role} />
                        </Divider.LeftContent>
                        <Divider.CenterLine />
                        <Divider.RightContent>
                            <Text
                                label="OT"
                                value={absentDetail.ot?.toString()}
                            />
                            <Text
                                label="Work Day"
                                value={absentDetail.workDay?.toString()}
                            />
                            <Text
                                label="Izin"
                                value={absentDetail.izin?.toString()}
                            />
                            <Text
                                label="Total"
                                value={absentDetail.total?.toString()}
                            />
                        </Divider.RightContent>
                    </Divider>
                    <MyCalendar
                        style={{ height: 1000 }}
                        localizer={localizer}
                        events={eventList}
                        views={['month']}
                        dayPropGetter={customDayPropGetter}
                    />
                    <div className={'flex my-2 justify-between'}>
                        {absentReportDetailId !== undefined &&
                        attendanceLogList?.findIndex(
                            (item) => item.userId === absentReportDetailId
                        ) > 0 ? (
                            <Button
                                color="light"
                                onClick={() => {
                                    dispatch(
                                        // setAbsentReportDetailIndex(
                                        //     attendanceLogDetailIndex - 1
                                        // )
                                        setAbsentReportDetailId(
                                            attendanceLogList[
                                                attendanceLogList.findIndex(
                                                    (item) =>
                                                        item.userId ===
                                                        absentReportDetailId
                                                ) - 1
                                            ].userId
                                        )
                                    );
                                }}
                            >
                                <HiOutlineArrowLeft className="mr-2 h-5 w-5" />
                                {
                                    attendanceLogList[
                                        attendanceLogList.findIndex(
                                            (item) =>
                                                item.userId ===
                                                absentReportDetailId
                                        ) - 1
                                    ].name
                                }
                            </Button>
                        ) : (
                            <div></div>
                        )}
                        {absentReportDetailId !== undefined &&
                            attendanceLogList?.findIndex(
                                (item) => item.userId === absentReportDetailId
                            ) <
                                attendanceLogList.length - 1 && (
                                <Button
                                    color="light"
                                    onClick={() => {
                                         dispatch(
                                      setAbsentReportDetailId(
                                          attendanceLogList[
                                              attendanceLogList?.findIndex(
                                                  (item) =>
                                                      item.userId ===
                                                      absentReportDetailId
                                              ) + 1
                                          ].userId
                                      ));
                                    }}
                                >
                                    {
                                        attendanceLogList[
                                            attendanceLogList?.findIndex(
                                                (item) =>
                                                    item.userId ===
                                                    absentReportDetailId
                                            ) + 1
                                        ].name
                                    }
                                    <HiOutlineArrowRight className="ml-2 h-5 w-5" />
                                </Button>
                            )}
                    </div>
                </>
            </FormLoader>
        </div>
    );
};
export default AbsenLogDetail;
